<div class="container">
    <div class="label">
        {{"bloc-help.need_help" | translate}}
    </div>
    <div class="button" (click)="redirect('https://aide.laposte.fr/')" dataqsi="helpButton">
        <a class="button_action">{{"bloc-help.online_help" | translate}}</a>
    </div>
</div>
